/**
 * `<NotFoundPage/>` — the app's not-found state for an address no route
 * claims (#2030).
 *
 * Rendered by the AppShell's `*` catch-all (way back: home) and by the
 * Setup layout's own `*` catch-all (way back: Setup), so a guessed Setup
 * address such as `/teams/<id>/setup/imports` keeps the Setup section list
 * on screen — the section the lead was after is one click away. It names
 * the address that was tried so a mistyped link reads as one.
 *
 * Breadcrumbs stay with the caller: the shell's catch-all sets
 * `Home › Not found`; under Setup the layout's `Home › <team> › Setup`
 * stands.
 */
import { Link, useLocation } from "react-router-dom";

import { Button, EmptyState } from "./ui";

export function NotFoundPage({
  backTo = "/",
  backLabel = "Back to home",
}: {
  backTo?: string;
  backLabel?: string;
}) {
  const { pathname } = useLocation();
  return (
    <div data-testid="not-found-page">
      <EmptyState
        title="Page not found"
        description={`Nothing lives at ${pathname}. The link may be old or mistyped.`}
        action={
          <Button asChild variant="secondary" size="sm">
            <Link to={backTo}>{backLabel}</Link>
          </Button>
        }
      />
    </div>
  );
}
